<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.keyword" clearable placeholder="名称/统一社会信用代码"
              @keyup.enter.native="search"></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
        </div>
        <div class="searchItem" style="margin-left: 10px;">
          <el-radio-group v-model="query.feeFilter" @change="search">
            <el-radio :label="0">显示不收取的</el-radio>
            <el-radio :label="1">显示收取的</el-radio>
            <el-radio :label="2">显示所有</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false" :showPage="true"
      :resizable="true" :total="query.total" :needBlackRow="false" :needPopMenu="false" :canbeEdit="false"
      :loading="loading" @pagechange="pagechange">
    </vggrid>
  </Container>
</template>
<script>
import request from '@/utils/request'
import vggrid from '../common/vggrid'
export default {
  name: 'purchaserFeeIndex',
  data() {
    return {
      loading: false,
      list: [],
      cols: [
        { type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 60 },
        { field: 'comfullname', fieldtype: 'C', title: '采购人名称', calculExpr: '', addNewRowFlg: false },
        { field: 'comidcode', fieldtype: 'C', title: '统一社会信用代码', calculExpr: '', addNewRowFlg: false, width: 220 },
        {
          field: 'bmfeeflg',
          fieldtype: 'C',
          title: '是否收报名费',
          calculExpr: '',
          addNewRowFlg: false,
          width: 130,
          slots: {
            default: ({ row }) => {
              return [
                <el-checkbox value={+row.bmfeeflg === 1}
                  onChange={(val) => this.changeFee(row, val)}></el-checkbox>,
              ]
            }
          }
        }
      ],
      query: {
        total: 0,
        limit: 20,
        offset: 0,
        keyword: '',
        // 报名费筛选：0=显示不收取的 1=显示收取的 2=显示所有
        feeFilter: 2
      }
    }
  },
  components: { vggrid },
  activated() {
    this.query.offset = 0
    this.getPageList()
  },
  methods: {
    async getPageList() {
      this.loading = true
      const res = await request({
        method: 'get',
        url: '/ywgl/coscomfee/getPageList',
        params: {
          cosid: this.$store.getters.loginUser.cosid,
          keyword: this.query.keyword,
          feeFilter: this.query.feeFilter,
          limit: this.query.limit,
          offset: this.query.offset
        }
      })
      this.list = (res && res.list) || []
      this.query.total = res && res.count && res.count.length ? res.count[0].count : 0
      this.loading = false
    },
    async search() {
      this.query.offset = 0
      await this.getPageList()
    },
    async pagechange({ currentPage, pageSize }) {
      this.query.limit = pageSize
      this.query.offset = (currentPage - 1) * pageSize
      await this.getPageList()
    },
    // 勾选即保存：勾选=写入一行（收报名费），取消=删除该行；失败回滚勾选
    async changeFee(row, val) {
      const target = val ? 1 : 0
      const old = +row.bmfeeflg === 1 ? 1 : 0
      if (target === old) return
      this.$set(row, 'bmfeeflg', target)
      const res = await request({
        method: 'post',
        url: '/ywgl/coscomfee/saveFee',
        data: {
          cosid: this.$store.getters.loginUser.cosid,
          comid: row.comid,
          bmfeeflg: target,
          userid: this.$store.getters.loginUser.userid
        }
      })
      if (res && res.issuccess === 1) {
        this.$message.success(target === 1 ? '已设置为收报名费' : '已设置为不收报名费')
      } else {
        this.$set(row, 'bmfeeflg', old)
        this.$message.error((res && res.msg) || '保存失败')
      }
    }
  }
}
</script>
